import Toll from './toll'
import TollSemiautomatico from './toll_semiautomatico'
import CheckApp from './check-app'
import Signalization from './signalization'

export default { Toll, TollSemiautomatico, CheckApp, Signalization }
